import { render } from "./FreeMonths.vue?vue&type=template&id=630a8aaa"
import script from "./FreeMonths.vue?vue&type=script&lang=js"
export * from "./FreeMonths.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__